import React from "react";
import type { Services as ServicesType } from "@repo/fetch-repository/services";
import { Link } from "@repo/i18n/routing";
import { ArrowButton } from "./arrow-button";
import VideoPlayer from "./video-player";

export function ServicesBenefit({
  services,
  title,
}: {
  services: ServicesType[];
  title: string;
}): React.JSX.Element {
  const pattern = ["A", "B", "C", "B"];
  return (
    <div className="w-full h-full flex flex-col gap-7 ">
      <div className="absolute ltr:left-10 rtl:right-10 top-1/2 lg:flex hidden">
        <div className="size-full relative flex items-center justify-center">
          <div className="absolute rtl:rotate-90 ltr:-rotate-90 font-thin lg:text-3xl text-xl px-2 text-gray-300 before:content-[''] before:inline-block before:bg-gray-300 before:h-px before:lg:w-14 before:w-10 after:content-[''] after:inline-block after:bg-gray-300 after:h-px after:lg:w-14 after:w-10 flex items-center">
            <span className="mx-2 uppercase rtl:-mt-3 whitespace-nowrap rtl:font-doran rtl:font-medium">
              {title}
            </span>
          </div>
        </div>
      </div>
      <h1 className="font-helvetica rtl:font-doran rtl:font-bold text-lg lg:text-3xl font-[100] leading-[1.07] text-[#6a6a6a]">
        {title}
      </h1>
      <div className="flex flex-col gap-y-10 lg:gap-y-12">
        {services.map((service, index) => (
          <Link
            className={`flex w-full justify-center group ${
              // eslint-disable-next-line no-nested-ternary -- disable-next-line prettier/prettier/single-quote
              pattern[index % pattern.length] == "A"
                ? "lg:justify-start"
                : pattern[index % pattern.length] == "B"
                  ? "lg:justify-center"
                  : "lg:justify-end"
            }`}
            href={`/services/${service.id}/${encodeURIComponent(
              service.name.replace(/\s+/g, "-").toLowerCase()
            )}`}
            key={service.id}
          >
            <div className="h-full flex flex-col lg:flex-row lg:gap-8 gap-6 items-center bg-white/5 rounded-lg backdrop-blur-sm">
              {/* eslint-disable-next-line no-nested-ternary -- disable */}
              {!Array.isArray(service.main_image.data) ? (
                service.main_image.data.url.includes("mp4") ? (
                  <div className="w-[100px] md:w-[150px] lg:w-[171px] h-[100px] md:h-[150px] lg:h-[171px]">
                    <VideoPlayer link={service.main_image.data.url} />
                  </div>
                ) : (
                  <img
                    alt={service.main_image.data.alt || service.name}
                    className="w-[100px] md:w-[150px] lg:w-[171px] h-[100px] md:h-[150px] lg:h-[171px] object-contain rounded-lg"
                    onError={(e) => {
                      e.currentTarget.src = "/images/placeholder.png";
                    }}
                    src={service.main_image.data.url}
                  />
                )
              ) : null}
              <div className="flex flex-col gap-y-3 items-center lg:items-start">
                <h1 className="text-[18px] md:text-[20px] lg:text-[25px] font-helvetica rtl:font-doran text-[#313131] font-[100] rtl:font-bold transition-colors group-hover:text-[#f70]">
                  {service.name}
                </h1>
                <div
                  className="line-clamp-1 mb-2 max-w-[200px] md:max-w-[200px] lg:max-w-[400px] overflow-hidden text-[15px] md:text-[18px] lg:text-[20px] font-helvetica rtl:font-doran text-[#6a6e77] font-[300] leading-[1.16]"
                  dangerouslySetInnerHTML={{ __html: service.detail }}
                />
                <div className="w-3/5 flex justify-center">
                  <ArrowButton />
                </div>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
